import { z } from "zod";
import { PresenceType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export const absenceGroupSchema = z.object({
  active: z.boolean(),
  name: z
    .string()
    .min(1, "Nazwa grupy jest wymagana.")
    .max(100, "Nazwa grupy jest za długa, maksymalnie 100 znaków"),
  description: z.optional(
    z
      .string()
      .max(255, "Opis grupy jest za długi, maksymalnie 255 znaków")
      .nullable()
  ),
  presenceType: z.enum(PresenceType),
  color: z.string().length(7).regex(/^#/, "Nieprawidłowy format koloru."),
});
